import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import SimpleCard from "../../../../components/card/simpleCard/simpleCard";
import ElementTitle from "../../../../components/title/elementTitle/elementTitle";
import { SALE_ID } from "../../../../config/cacheKey";
import { IGetCustomerSaleResponse } from "../../../../models/sale.model";
import { changeRouteType, getpervInnerState } from "../../../../redux/handleBackBtn/handleBackBtnSlice";
import { setHeaderTitle } from "../../../../redux/headerTitle/headerTitleSlice";
import { GetCustomerSale } from "../../../../services/sale.service";
import LoansSkeleton from "../../loansTab/Loans/loansSkeleton";
export default function TradePurchaseDetail() {
    const dispatch = useDispatch();
    const [data, setData] = useState<IGetCustomerSaleResponse>();
    const queryClient = useQueryClient();
    const saleId: number = queryClient.getQueryData(SALE_ID)!;
    const randomKeyForDispatch = Math.random();
    const { mutateAsync, isLoading } = useMutation(GetCustomerSale, {
        onSuccess: (data) => {
            setData(data)
        }
    });
    useEffect(() => {
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'جزییات خرید', parentRoute: 'purchase' }));
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `tradeProfile ${randomKeyForDispatch}` }));
        mutateAsync({ saleId: saleId! });
    }, []);
    const purchase = [{ id: 0, title: 'شناسه خرید', value: data?.factorNumber },
    { id: 1, title: 'تاریخ  و زمان خرید', value: data?.salesDatePersian },
    { id: 3, title: 'شناسه پرداخت نقدی', value: data?.onlineTransactionNumber }].filter(item => item.value != null);

    if (isLoading) {
        return <LoansSkeleton />;
    }
    return (
        <div className="p-5" style={{ height: 'calc(100svh - 120px)', overflowY: 'scroll' }}>
            <div className="flex flex-col items-center justify-center gap-3 mb-10">
                <img style={{ rotate: "90deg", transform: "scaleX(-1)" }} className="w-30 h-40 object-cover" src='/images/gold.png' />
                <div style={{ color: "var(--primary-text-color)", fontSize: '1rem', textAlign: "center" }}>
                    <span style={{ color: '#BBA57A', fontSize: '0.8rem', fontWeight: "bold" }}>{data?.saleItems[0].quantity}</span> گرم {data?.saleItems[0].title} <br /> با موفقیت خریداری شد.
                </div>
            </div>

            {data?.saleTransactions && data?.saleTransactions.length > 0 &&
                <>
                    <div className="mt-5">
                        <ElementTitle title=" تراکنش ها (ریال)" />
                    </div>
                    <SimpleCard>
                        {data?.saleTransactions?.map((item) => (
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                                <div style={{ alignContent: "flex-start" }}>
                                    <span style={{ fontWeight: "normal", paddingRight: "5px", fontSize: '.85rem', color: "var(--tirnary-text-color)" }}>{item.title} </span>
                                </div>
                                <div style={{ alignContent: "flex-end" }}>
                                    <span style={{ color: "var(--primary-text-color)", fontSize: '.85rem' }}> {item.amount?.toLocaleString()} ریال</span>
                                </div>
                            </div>
                        ))}
                    </SimpleCard>
                </>
            }

            <div className="mt-5">
                <ElementTitle title={data?.storeTitle || ""} />
            </div>
            <SimpleCard>
                {purchase.map((item) => {
                    const isLong = item?.value && item?.value?.toString().length > 17;

                    return (
                        <div style={{ display: "flex", flexDirection: isLong ? "column" : "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontWeight: "normal", paddingRight: "5px", fontSize: '.85rem', color: "var(--tirnary-text-color)" }}>{item.title} </span>
                            </div>
                            <div style={{ alignContent: "flex-end" }}>
                                <span style={{ color: "var(--primary-text-color)", fontSize: '.85rem' }}> {item.value} </span>
                            </div>
                        </div>
                    )
                })}
            </SimpleCard>
        </div>
    )
}
